import Vue from 'vue'
import VueRouter from 'vue-router'
import inputSpace from './inputSpace'
import transferSpace from './transferSpace'
import dataProcessing from './dataProcessing'

Vue.use(VueRouter)

// 解决路由重复跳转报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/infoInput/entry'
  },
  {
    path: '/noauth',
    meta: { title: '登录超时' },
    component: () => import('@/view/pages/noauth')
  },
  // layout
  {
    path: '/infoInput',
    redirect: '/infoInput/entry',
    component: () => import('@/Layout.vue'),
    children: [...inputSpace, ...transferSpace, ...dataProcessing]
  }
]

const router = new VueRouter({ routes }) // 创建 router 实例
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } // 修改页面title
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js